import { render, staticRenderFns } from "./SchedulePeriodOverlay.vue?vue&type=template&id=04c05380&scoped=true"
import script from "./SchedulePeriodOverlay.vue?vue&type=script&lang=js"
export * from "./SchedulePeriodOverlay.vue?vue&type=script&lang=js"
import style0 from "./SchedulePeriodOverlay.vue?vue&type=style&index=0&id=04c05380&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c05380",
  null
  
)

export default component.exports